var map = {
	"./ar.json": "3027",
	"./de.json": "b5d9",
	"./en.json": "36e0",
	"./es.json": "eee7",
	"./fr.json": "a016",
	"./it.json": "73c1",
	"./mr.json": "6261",
	"./pl.json": "5a42",
	"./pt.json": "3726",
	"./ru.json": "354f",
	"./tr.json": "3609"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f11";